import React, { useMemo } from 'react'
import { useTable } from 'react-table'
import { displayDate } from '../../utils/dateTime'
import { stringToSEO } from '../../utils/stringOps'

function ShowRelatedPortfolios ({ relatedContents }) {
  const columns = useMemo(() => [
    {
      Header: 'Date',
      accessor: d => {
        return displayDate(d.publishedDate)
      },
      width: '100px'
    },
    {
      Header: 'Title',
      accessor: d => {
        return <a
          href={`/#/content/${d.id}/${stringToSEO(d.title)}?referrer=portfolio_openrelatedportfolio`} rel='noopener noreferrer' target='_self'> {d.title} </a>
      },
      width: ''
    }
  ],
  []
  )

  const data = relatedContents || []

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  })

  return (
    <div className='article-relatedPortfolio'>

      {(data.length > 0) ? (
        <div>
          <h4 className='table-heading'>Related Portfolio(s)</h4>
          <table {...getTableProps()}>
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th width={column.width} {...column.getHeaderProps()}>{column.render('Header')}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row)
                return (
                  <tr className='separated-solid' {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      ) : null}

    </div>
  )
}

export default ShowRelatedPortfolios
